import { MathResult } from "@/financeModels/types";
import { monospaceFontFamily } from "@/theme";
import { toNumberOrNull } from "@/utils/math";
import { formatMoneyErase00Decimal } from "@/utils/moneyFormating";
import {
  Box,
  BoxComponentProps,
  Group,
  Input,
  Paper,
  Stack,
} from "@mantine/core";
import { ReactNode } from "react";

export const ComputedResult = ({
  label,
  value,
  variant = "light",
  ...props
}: BoxComponentProps & {
  label: ReactNode;
  value: ReactNode;
  variant?: "light" | "default";
}) => {
  if (variant === "default")
    return (
      <Group my="sm" justify="space-between" {...props}>
        <Input.Label component={"div"} size="sm" m={0} mb={0}>
          {label}
        </Input.Label>
        <Box w={120}>
          <Input.Label component={"div"} size="sm" m={0} mb={0}>
            {value}
          </Input.Label>
        </Box>
      </Group>
    );

  return (
    <ComputedResultContainer {...props}>
      <ComputedResultLine label={label} value={value} />
    </ComputedResultContainer>
  );
};

export const ComputedResultContainer = ({
  children,
  ...props
}: BoxComponentProps & { children: ReactNode }) => {
  return (
    <Paper mt={"xs"} bg={"gray.1"} p="xs" py="sm" withBorder {...props}>
      <Stack gap="xs">{children}</Stack>
    </Paper>
  );
};

export const ComputedResultLine = ({
  label,
  value,
}: {
  label: ReactNode;
  value: ReactNode;
}) => {
  return (
    <Group justify="space-between" wrap="nowrap">
      <Input.Label component={"div"} size="sm" m={0} mb={0}>
        {label}
      </Input.Label>

      <Input.Label
        component={"div"}
        size="sm"
        m={0}
        p={0}
        mb={0}
        ff={monospaceFontFamily}
        style={{
          whiteSpace: "nowrap",
        }}
      >
        {value}
      </Input.Label>
    </Group>
  );
};

export const ComputedDollarResult = ({
  value,
}: {
  value: MathResult | number | null | undefined;
}) => {
  if (value === null || value === undefined || toNumberOrNull(value) === null)
    return <span>---</span>;

  const fommatedValue = formatMoneyErase00Decimal(toNumberOrNull(value));

  if (Number(value) < 0) {
    return (
      <span style={{ color: "var(--mantine-color-red-9)" }}>
        ({fommatedValue.replace("-", "")})
      </span>
    );
  }

  return <span>{fommatedValue}</span>;
};
